export interface DailyPriceProps {
    date: string;
    price: string;
    priceChange: string;
    percentageChange: string;
    showIcon?: boolean;
    percentageUpIcon?: string;
    percentageDownIcon?: string;
    iconPosition?: string;
}

function DailyPriceWidget(props: DailyPriceProps) {
    const {
        date,
        price,
        priceChange,
        showIcon,
        percentageChange,
        percentageUpIcon,
        percentageDownIcon,
        iconPosition,
    } = props;
    const isNegativeChange = parseFloat(percentageChange.trim().replace(',', '.')) > 0;
    const iconName = isNegativeChange ? percentageUpIcon : percentageDownIcon;
    const isNegative = !isNegativeChange;
    return (
        <div className="daily-price-wrapper">
            <div className="date">{date || 'As of Jun 30, 2020??'}</div>
            <div className="price" data-testid={'price'}>
                {price || '$11.6177??'}
            </div>
            <div
                className={`price-change ${isNegative ? 'negative' : ''}`}
                data-testid={'price-nagative'}
            >
                {showIcon && (
                    <span
                        className={`icon ${iconPosition === 'Right' ? 'icon-right' : 'icon-left'}`}
                    >
                        <i className={iconName} />
                    </span>
                )}
                {`${priceChange} | ${percentageChange}` || '$0.0258 | 0.23%??'}
            </div>
        </div>
    );
}

export default DailyPriceWidget;
